import { IComponentProps } from "@starrez/starryui";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { Message } from "../../components/Message";
import { ISnackBarContext, ISnackBarContextProviderProps } from "./";

export const SnackBarContext = createContext<ISnackBarContext>({});

const AUTO_DISMISS = 2500;

const SnackBarContextProvider = ({ children }: ISnackBarContextProviderProps) => {
    const [message, setMessage] = useState<IComponentProps | null>(null);

    useEffect(() => {
        if (message !== null) {
            const timer = setTimeout(() => setMessage(null), AUTO_DISMISS);
            return () => clearTimeout(timer);
        }
    }, [message]);

    const addMessage = useCallback((content) => setMessage(content), []);

    const value = {
        AddMessage: addMessage,
    };

    return (
        <SnackBarContext.Provider value={value}>
            {children}
            {message && (
                <Message {...message} />
            )}
        </SnackBarContext.Provider>
    );
};

export default SnackBarContextProvider;
